TS.ns('WL');

WL.leasingActionEditViewModel = new Class({
    Extends: TS.domain.EditDomain,

    createProperties: function (config) {
        var me = this;
        me.parent(config);

        var propertyList = me.getDomainProperty('PropertyList');

        if (propertyList) {
            propertyList.on('addNew', me.onPropertyAdded);
            propertyList.on('cellValueChanged', me.onPropertyChanged, me);
        }

        var ownerList = me.getDomainProperty('lkpOwner_Property');
        if (ownerList) {
            ownerList.autoSelect = true;
        }

        var responsibleList = me.getDomainProperty('lkpResponsibleGroup_Property');
        if (responsibleList) {
            responsibleList.autoSelect = true;
        }

        me.lkpActionType_Property.on('selectionChanged', me.onActionTypeChanged, me);
    },

    onActionTypeChanged: function (newValue) {
        var me = this;

        me.performServerCommand({
            cmd: 'GetActionPropertyList',
            submitModel: true,
            blockUI: true,
            callback: function () {
                me.PropertyList.getFieldByName('PropertyLkp').invalidateList();
            }

        });
    },

    onPropertyAdded: function (e) {
        var me = this,
          rec = e.item;

        rec.PropertyTypeCode = new ko.observable('Text');
        rec.EditorName = new ko.observable('Text');
        rec.EditorType = new ko.observable('Text');
    },

    onPropertyChanged: function (e) {
        var me = this,
          rec = e.item;

        if (e.fieldName != 'PropertyId')
            return;

        me.performServerCommand({
            cmd: 'RefreshProperty',
            submitModel: true,
            extraData: {
                NewValue: e.newValue,
                rowIdx: e.rowIdx
            },
            blockUI: true
        })
    }
});